module.exports = __webpack_public_path__ + "static/year_portrait_with_week_numbers-fddb06f0b210dce33cd447da20c4f3d1.png";